import { useEffect, useRef } from 'react';
import isSSR from '../../../utils/isSSR';
const AUTO_RELOAD_TIME_OUT = 5 * 60 * 1000;
const useAutoReload = (dependency, timeoutMs = AUTO_RELOAD_TIME_OUT) => {
    const dependencyRef = useRef();
    useEffect(() => {
        const hasChanged = dependency !== dependencyRef.current;
        if (!hasChanged || isSSR())
            return;
        const timer = setTimeout(() => {
            window.location.reload();
        }, timeoutMs);
        dependencyRef.current = dependency;
        return () => {
            clearTimeout(timer);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dependency]);
};
export default useAutoReload;
